import { useRef, useState } from "react";

interface UseOtpVerificationOptions {
  length?: number;
  onVerified?: () => void;
}

export const useOtpVerification = ({
  length = 4,
  onVerified,
}: UseOtpVerificationOptions = {}) => {
  const [otp, setOtp] = useState<string[]>(Array(length).fill(""));
  const [token, setToken] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const otpRefs = Array.from({ length }, () => useRef<HTMLInputElement>(null));
  const validateOtp = () => {
    if (otp.join("") === token) {
      setIsVerified(true);
      setShowOtp(false);
      console.log("✅ OTP Verified");
    } else {
      //alert("Invalid OTP");
      console.log("Invalid OTP");
    }
  };

  const sendOtp = async () => {
    const generated = Math.floor(
      Math.pow(10, length - 1) + Math.random() * Math.pow(10, length - 1)
    ).toString();

    setToken(generated);
    setVerifying(true);

    // 🔴 Replace with real API
    await new Promise((r) => setTimeout(r, 600));

    setShowOtp(true);
    setVerifying(false);

    console.log("OTP:", generated); // dev only
    //alert("OTP generated");
    console.log("OTP generated");
  };

  const handleOtpChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) return;

    const next = [...otp];
    next[index] = value;
    setOtp(next);

    if (value && index < length - 1) {
      otpRefs[index + 1].current?.focus();
    }

    if (next.join("") === token) {
      setIsVerified(true);
      setShowOtp(false);
      onVerified?.();
    }
  };

  const resetOtp = () => {
    setOtp(Array(length).fill(""));
    setShowOtp(false);
    setIsVerified(false);
    setToken("");
  };

  return {
    otp,
    otpRefs,
    showOtp,
    verifying,
    isVerified,
    sendOtp,
    handleOtpChange,
    validateOtp,
    resetOtp,
  };
};
